export default __webpack_public_path__ + "static/media/logo.8443c3ce.png";